import DocumentService from '@/Modules/Document/DocumentService.js'

export default class BinderDocumentService extends DocumentService {
  static resource = 'binders'
}
